goog.provide("shadow.js.shim.module$$mui$material$useMediaQuery$default");
shadow.js.shim.module$$mui$material$useMediaQuery$default = shadow.js.require(311, {})["default"];
